// libraries.
import { Modal, Form, Button, Spinner } from "react-bootstrap";
import { electricPurple500, monserratSemiBold } from "@habitech/shared";

// interfaces.
import { IncentiveStep } from "../../rulesData";
import { RawRuleItem } from "@store/apiSlices/incentiveRules/interfaces/rawRules.interfaces";

// hook.
import { useEditStepForm } from "./useEditStepForm";

// components.
import { EditStepFields } from "./EditStepFields";

interface Props {
  step: IncentiveStep | null;
  rawRule: RawRuleItem | null;
  country: string;
  onClose: () => void;
}

export const EditStepModal = ({ step, rawRule, country, onClose }: Props) => {
  const { methods, onSubmit, isSaving, hasDayRange, hasPercentage, subConditionArray } = useEditStepForm({
    step,
    rawRule,
    country,
    onClose,
  });

  return (
    <Modal show={step !== null} onHide={onClose} centered>
      <Modal.Header
        closeButton
        style={{ borderBottom: `2px solid ${electricPurple500}` }}
      >
        <Modal.Title
          style={{ fontFamily: monserratSemiBold, fontWeight: 600, fontSize: 16 }}
        >
          Editar paso de incentivo
        </Modal.Title>
      </Modal.Header>

      <Form onSubmit={onSubmit}>
        <Modal.Body style={{ overflowY: "auto", maxHeight: "65vh" }}>
          <EditStepFields
            register={methods.register}
            errors={methods.formState.errors}
            watch={methods.watch}
            setValue={methods.setValue}
            hasDayRange={hasDayRange}
            hasPercentage={hasPercentage}
            subConditionArray={subConditionArray}
            emptySubCondition={{ left: "", type: "equals", right: "" }}
          />
        </Modal.Body>

        <Modal.Footer style={{ borderTop: "1px solid #eee" }}>
          <Button
            className="btn-habi-white"
            onClick={onClose}
            disabled={isSaving}
          >
            Cancelar
          </Button>
          <Button type="submit" className="btn-habi" disabled={isSaving}>
            {isSaving ? (
              <Spinner size="sm" animation="border" />
            ) : (
              "Guardar cambios"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
